import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';

document.querySelectorAll('.js-home-hero__slider').forEach((slider) => {
    const prev = slider.querySelector('.js-home-hero__slider-prev');
    const next = slider.querySelector('.js-home-hero__slider-next');

    new Swiper(slider, {
        modules: [Navigation, Autoplay],

        slidesPerView: 1,
        loop: true,

        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },

        navigation: {
            prevEl: prev,
            nextEl: next,
        },
    });
});